import React, { useContext, useEffect } from 'react';
import GlobalContext from '../../contexts/GlobalContext';

type Props = {
  message: string;
  closePopUp: Function;
};

const ThankYouPopupDoNotSell = (props: Props): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const clickOkayButton = (): void => {
    globalContext.gtm.pushVersionedEvent(
      '2.11',
      'CCPARequest',
      'ClickOkayButton',
      '',
      null,
      true
    );
    props.closePopUp();
  };
  useEffect(() => {
    globalContext.gtm.setVirtualPage('Do_Not_Sell_Request_Submitted');
  }, []);
  return (
    <div className="privacy-ccpa-thanks">
      <div className="regulatory-updates-modal__header">
        <h2 className="regulatory-updates__heading js-regulatory-updates-modal-heading">
          Do Not Sell or Share My Personal Information
        </h2>
      </div>
      <p className="regulatory-updates__para privacy-ccpa-thanks__para">
        {props.message}
      </p>
      <div>
        <button
          className="base-button base-button--full-width regulatory-updates-modal__btn sj-button base-button--activation"
          type="submit"
          onClick={(): void => clickOkayButton()}>
          okay
        </button>
      </div>
    </div>
  );
};

export default ThankYouPopupDoNotSell;
